var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureCarLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_3221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8419 33.8238C42.8619 33.5238 42.9219 33.2238 42.9219 32.9238V33.9238L42.8419 33.8238ZM22.9219 32.9238C22.9219 34.3438 23.2219 35.7038 23.7619 36.9238H12.9219V38.9238C12.9219 40.0238 12.0219 40.9238 10.9219 40.9238H8.92188C7.82187 40.9238 6.92188 40.0238 6.92188 38.9238V22.9238L11.0819 10.9238C11.4819 9.76383 12.6019 8.92383 13.9219 8.92383H35.9219C37.2419 8.92383 38.3619 9.76383 38.7619 10.9238L42.9219 22.9238V32.9238C42.9219 27.4038 38.4419 22.9238 32.9219 22.9238C27.4019 22.9238 22.9219 27.4038 22.9219 32.9238ZM16.9219 27.9238C16.9219 26.2638 15.5819 24.9238 13.9219 24.9238C12.2619 24.9238 10.9219 26.2638 10.9219 27.9238C10.9219 29.5838 12.2619 30.9238 13.9219 30.9238C15.5819 30.9238 16.9219 29.5838 16.9219 27.9238ZM38.9219 20.9238L35.9219 11.9238H13.9219L10.9219 20.9238H38.9219Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4023 30.3516H37.627V28.8008C37.627 26.6607 35.8901 24.9238 33.75 24.9238C31.6099 24.9238 29.873 26.6607 29.873 28.8008V30.3516H29.0977C28.2447 30.3516 27.5469 31.0494 27.5469 31.9023V39.6562C27.5469 40.5092 28.2447 41.207 29.0977 41.207H38.4023C39.2553 41.207 39.9531 40.5092 39.9531 39.6562V31.9023C39.9531 31.0494 39.2553 30.3516 38.4023 30.3516ZM31.4238 28.8008C31.4238 27.5136 32.4629 26.4746 33.75 26.4746C35.0371 26.4746 36.0762 27.5136 36.0762 28.8008V30.3516H31.4238V28.8008ZM38.4023 39.6562H29.0977V31.9023H38.4023V39.6562ZM33.75 37.3301C34.6029 37.3301 35.3008 36.6322 35.3008 35.7793C35.3008 34.9264 34.6029 34.2285 33.75 34.2285C32.8971 34.2285 32.1992 34.9264 32.1992 35.7793C32.1992 36.6322 32.8971 37.3301 33.75 37.3301Z",
    fill: "#8F4300",
    fillOpacity: 0.5,
    stroke: "#8F4300",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36719 48.9922L49.3059 1.05343",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_3221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.921875 0.923828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureCarLock);
export default __webpack_public_path__ + "static/media/Feature_CarLock.69934dad19634d37e5b8a3bb816c6617.svg";
export { ForwardRef as ReactComponent };